import { colors, palette } from './colors'
import gridConfig from './grid'
import fonts from './fonts'
import layout, { getBreakpointsInPixels } from './layout'

const theme = {
  fonts,
  colors,
  palette,
  layout,

  // Grid config required for 'react-awesome-styled-grid' library
  awesomegrid: gridConfig,

  // Breakpoints required for 'style-breakpoints' library
  breakpoints: getBreakpointsInPixels(layout.breakpoints)
}

export default theme
